import request from '@/utils/request'

/**
 * 首页页尾友情链接获取列表信息
 * @param {} data 
 * @returns 
 */
export function getfootList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetFootList',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/foot.js